import { z } from 'zod';

export const productValidationSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Product name is required')
    .max(95, 'Product name must not exceed 95 characters'),
  description: z
    .string()
    .trim()
    .min(1, 'Product description is required'),
  price: z
    .union([z.string(), z.number()])
    .refine((val) => val !== '' && val !== null && val !== undefined, {
      message: 'Product price is required',
    })
    .refine((val) => !isNaN(Number(val)) && Number(val) >= 0, {
      message: 'Price must be a valid non-negative number',
    }),
  tax_percentage: z
    .union([z.string(), z.number()])
    .refine((val) => val !== '' && val !== null && val !== undefined, {
      message: 'Tax percentage is required',
    })
    .refine((val) => !isNaN(Number(val)) && Number(val) >= 0 && Number(val) <= 100, {
      message: 'Tax percentage must be between 0 and 100',
    }),
  quantity: z
    .union([z.string(), z.number()])
    .refine((val) => val !== '' && val !== null && val !== undefined, {
      message: 'Quantity is required',
    })
    .refine((val) => !isNaN(Number(val)) && Number(val) >= 0, {
      message: 'Quantity must be a valid non-negative number',
    }),
  discount_percantage: z
    .union([z.string(), z.number()])
    .optional()
    .refine(
      (val) => {
        if (!val && val !== 0) return true;
        const num = Number(val);
        return !isNaN(num) && num >= 0 && num <= 100;
      },
      { message: 'Discount must be between 0 and 100' }
    ),
  brand_id: z.string().min(1, 'Please select a brand'),
  category_id: z.string().min(1, 'Please select Category Level 1'),
  subcategory_id: z.string().min(1, 'Please select Category Level 2'),
  sub_subcategory_id: z.string().optional(),
  status: z.boolean().default(true),
  is_featured: z.boolean().default(false),
});

export type ProductFormValues = z.infer<typeof productValidationSchema>;
